import { render, staticRenderFns } from "./viewHazardList.vue?vue&type=template&id=3413b1cb&scoped=true&"
import script from "./viewHazardList.vue?vue&type=script&lang=ts&"
export * from "./viewHazardList.vue?vue&type=script&lang=ts&"
import style0 from "./viewHazardList.vue?vue&type=style&index=0&id=3413b1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413b1cb",
  null
  
)

export default component.exports